<template>
  <Table name="tree-abonents" :columns=columns :fetch=sortData :state="'?sort=port'" 
    title="<i class='fa fa-users'></i>&nbsp; Абоненты" :cellClass=align :rowClass=levels 
    :dynamic=true ref="table"
    >
  
    <template #onu_mac="{rec}">
      {{ common.formatMac(rec.onu_mac) }}
    </template>
    
    <template #online="{rec}">
      <Icon name="star" :class="{active: rec.duration}" class="star" />
    </template>

    <template #temperature="{rec}">
      <template v-if="rec.temperature">{{rec.temperature}}&deg;</template>
    </template>

    <template #olt_rx="{rec}">
      <template v-if="rec.olt_rx">{{rec.olt_rx}} dBm</template>
    </template>

    <template #onu_rx="{rec}">
      <template v-if="rec.onu_rx">{{rec.onu_rx}} dBm</template>
    </template>

    <template #onu_tx="{rec}">
      <template v-if="rec.onu_tx">{{rec.onu_tx}} dBm</template>
    </template>

    <template #problems="{rec}">
      <span v-html="rec.problems.join('<br/>')"></span>
    </template>
    
    <template #ping="{rec}">
      <Ping :ip="rec.ip" v-if="rec.ip" :ref="`ip-${rec.ip}`" />
    </template>

    <template #login="{rec}">
      <a :href="`/client/${rec.uid}`">{{rec.login}}</a> <span style="font-size: smaller">{{rec.connection_type}}</span>
    </template>

    <template #title-extra>
      <span style="font-size: smaller" >
        <template v-if=showPeriod>
        Интервал:&nbsp;
        <select v-model="selectedTimespan" >
          <option v-for="o in timespan" :key="o.value" :value="o.value" >{{o.text}}</option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;
        </template>
        <Icon name="transfer" title="Пинговать всех" @click=pingAll />
      </span>
    </template>
    
    <template #duration="{rec}">
      {{ common.formatUptime(rec.duration) }}
    </template>

    <template #last_seen="{rec}">
      {{ common.formatLocalTime(rec.last_seen) }}
    </template>
  
  </Table>
</template>

<script>
import darsan from "darsan"
import {ipToNumber} from "common"

import Table from "common/visual/SimpleTable.vue"
import Ping from "common/visual/spec/Ping.vue"

export default {

  name: "PonAbonents",
    
  components: {Table, Ping},
    
  props:
  {
    onus: Object,
    showPeriod: false,
  },
  
  data()
  {
    return {
      ready: false,
      abonents: [],
      
      columns: [
        {name: "online", title: "", sort: true},
        {name: "name", title: "ONU"},
        {name: "onu_port", title: "Порт", sort: true},
        {name: "vlan", title: "VLAN", sort: true},
        {name: "onu_mac", title: "MAC ONU", sort: true},
        {name: "olt_rx", title: "OLT Rx", sort: true},
        {name: "onu_rx", title: "ONU Rx", sort: true},
        {name: "onu_tx", title: "ONU Tx", sort: true},
        {name: "temperature", title: "Температура", sort: true},
        {name: "problems", title: "Проблемы ONU"},
        {name: "login", title: "Логин", sort: true},
        {name: "mac", title: "MAC абонента", sort: true},
        {name: "last_seen", title: "Был виден", sort: true},
        {name: "ip", title: "IP", sort: true},
        {name: "duration", title: "Сессия", sort: true},
        {name: "ping", title: "Пинг"},
      ],
      
      timespan: [
        {text: "1 час", value: "1:00"},
        {text: "2 часа", value: "2:00"},
        {text: "12 часов", value: "12:00"},
        {text: "Сутки", value: "1.00:00"},
        {text: "Двое суток", value: "2.00:00"},
        {text: "Неделя", value: "7.00:00"},
        {text: "Две недели", value: "14.00:00"},
        {text: "Месяц", value: "30.00:00"},
      ],
      
      selectedTimespan: "7.00:00",
    }
  },
  
  methods: {
    async fetchData()
    {
      const abons = []
      
      for (const onu of this.onus.filter(el => !el._empty))
      {
        const mac_seen = {}

        for (const a of onu.fdb)
        {
          mac_seen[a.mac] = 1
          
          abons.push({
            onu_port: onu.onu_port,
            name: onu.name,
            problems: onu.problems,
            olt_rx: onu.olt_rx,
            onu_rx: onu.onu_rx,
            onu_tx: onu.onu_tx,
            temperature: onu.temperature,
            onu_mac: onu.mac,
            level: onu.level,
            mac: a.mac,
            vlan: a.vlan,
          })
        }
        
        for (const a of onu.old_fdb)
        {
          if (mac_seen[a.mac]) continue

          abons.push({
            onu_port: onu.onu_port,
            name: onu.name,
            problems: onu.problems,
            olt_rx: onu.olt_rx,
            onu_rx: onu.onu_rx,
            onu_tx: onu.onu_tx,
            temperature: onu.temperature,
            onu_mac: onu.mac,
            level: onu.level,
            mac: a.mac,
            vlan: a.vlan,
            last_seen: a.time,
          })
        }
      }
      
      const macs = abons.map(el => el.mac.replace(/:/g,"")).join(",")

      if (macs)
      {
        const clients = await darsan.post("", "client", "/clients-from-macs", {macs})
        const byMac = Object.fromEntries(clients.map(el => [el.mac, el]))

        for (const a of abons)
        {
          const rec = byMac[a.mac]
          if (!rec) continue

          a.ip = rec.ip
          a.duration = rec.duration
          a.uid = rec.uid
          a.login = rec.login
          a.connection_type = rec.connection_type
        }
      }
      
      this.abonents = abons
      this.ready = true
    },
 
    async sortData(sortBy, asc)
    {
      if (!this.ready) await this.fetchData()
      
      const threshold = moment().subtract(moment.duration(this.selectedTimespan))
      let sorted = this.abonents.filter(el => moment(el.last_seen).isAfter(threshold, "second"));
      
      switch(sortBy)
      {
        case "online":
          sorted = sorted.toSorted((a,b) => !!b.deregistered - !!a.deregistered)
        break;
        case "name":
        case "mac":
        case "onu_mac":
          sorted = sorted.toSorted((a,b) => a[sortBy].localeCompare(b[sortBy]))
        break
        case "last_seen":
          sorted = sorted.toSorted((a,b) => moment(a.tstamp).unix() - moment(b.tstamp).unix())
        break;
        case "ip":
          sorted = sorted.toSorted((a,b) => (a.ip ? ipToNumber(a.ip) : 0) - (b.ip ? ipToNumber(b.ip) : 0))
        break
        default: 
          sorted = sorted.toSorted((a,b) => a[sortBy] - b[sortBy])
      }

      return asc ? sorted : sorted.toReversed()
    },
    
    align(column)
    {
      return ["onu_port", "onu_rx", "olt_rx", "onu_tx", "temperature"].includes(column.name) ? "r" : ""
    },
    
    levels(rec)
    {
      return `onu-port-level-${rec.level}`
    },

    pingAll()
    {
      Object.keys(this.$refs).filter(k => k.substring(0,3) == "ip-").forEach(k => this.$refs[k].ping())
    },
    
  },
  
  watch: {
    async onus()
    {
      this.ready = false
      await this.fetchData()
      this.$refs.table.reloadTable()
    },

    async selectedTimespan()
    {
      this.$refs.table.reloadTable()
    }
  },

  
}
</script>

<style scoped>
.star.active
{
  color: green;
}
</style>

<style>
.onu-port-level-0
{
}

.onu-port-level-1
{
  background: LightGoldenRodYellow !important;
}

.onu-port-level-2
{
  background: LightSalmon !important;
}

.onu-port-level-3
{
  background: LightPink !important;
}

.star
{
  color: darkred;
}

</style>
